<template>
  <div>
    <div class="container admindashboard-content">
      <div class="pt-10 pb-5 text-left container-content" style="margin-left:0; margin-right:0">
        <h4 class="heading mt-5">Admin Dashboard</h4>
      </div>
      </div>
  <div class="container admindashboard">
    <div class="row pt-10 pb-5 text-left container-content" style="margin-left:0; margin-right:0">
      <div>
        <b-row class="mt-3 mb-3">
          <b-col>
            <label class="label label-org">Organization Name</label>
            <input
              aria-label="Website URL"
              id="add_company_website_url"
              placeholder="Search here"
              maxlength="255"
              type="text"
              aria-required="true"
              class="form-control"
              @input="onSearchOrgName"
            />
          </b-col>
          <b-col>
            <label class="label label-org"
              >Organization Type</label
            >
            <div class="dropdown "  id="selectOrgType">
              <button class="btn  dropdown-toggle " type="button" id="dropdownMenuButtonSelectOrgType" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"

             >
                {{ selectedOrgType ===''?"Select Type": selectedOrgType}}
              </button>
              <div class="dropdown-menu " aria-labelledby="dropdownMenuButtonSelectOrgType">
                <a class="dropdown-item" style="cursor: pointer" @click="onChangeOrgType('')" :class="{ active: selectedOrgType === '' }">
                  Select Type
                </a>
                <a class="dropdown-item" style="cursor: pointer" @click="onChangeOrgType(key)" v-for="(type, key) in organizationTypes"
                :value="key"
                v-bind:key="key" :class="{ active: selectedOrgType === key }">
                  {{ type }}
                </a>
              </div>
            </div>
          </b-col>
          <b-col>
            <label class="label label-org"
              >Member Type</label
            >
            <div class="dropdown " id="selectMemberType">
              <button class="btn  dropdown-toggle " type="button" id="dropdownMenuButtonSelectMemberType" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"

             >
                {{ selectedMemberType ===''?"Select Type": selectedMemberType}}
              </button>
              <div class="dropdown-menu " aria-labelledby="dropdownMenuButtonSelectMemberType">
                <a class="dropdown-item" style="cursor: pointer" @click="onChangeMemberType('')" :class="{ active: selectedMemberType === '' }">
                  Select Type
                </a>
                <a class="dropdown-item" style="cursor: pointer" @click="onChangeMemberType(key)" v-for="(type, key) in membershipTypes"
                :value="key"
                v-bind:key="key" :class="{ active: selectedMemberType === key }">
                  {{ type }}
                </a>
              </div>
            </div>
          </b-col>
          <b-col>
            <label class="label label-org"
              >Onboarding Status</label
            >
            <div class="dropdown ">
              <button class="btn  dropdown-toggle " type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              :class="selectedStatus.length>20 && selectedStatus.length<=30?'medium-fornt':selectedStatus.length>30?'small-fornt':'large-fornt'"
             >
                {{ selectedStatus ===''?"Select Status": selectedStatus}}
              </button>
              <div class="dropdown-menu " aria-labelledby="dropdownMenuButton" :class="items === null || items?.length <=5?'scroll-bar':''">
                <a class="dropdown-item" style="cursor: pointer" @click="onChangeStatus('')" :class="{ active: selectedStatus === '' }">
                  Select Status
                </a>
                <a class="dropdown-item" style="cursor: pointer" @click="onChangeStatus(key)" v-for="(type, key) in organizationProgressTypes"
                :value="key"
                v-bind:key="key" :class="{ active: selectedStatus === key }">
                  {{ type }}
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="container-content">
          <b-col>
            <b-table
              id="app-table"
              show-empty
              empty-text="No records found"
              :items="items"
              class="mt-3 table-border"
              responsive
              :fields="fields"
              @sort-changed="onSortChanged"
              bordered
            >
              <template v-slot:cell(firstName)="data">
                  {{ data.item.firstName }} {{ data.item.lastName }}
              </template>
              <template v-slot:cell(status)="data">
                  {{ (data.item.status)?.replaceAll('_', ' ')?.toLowerCase().replace(/(?:^|\s)\w/g, function(match) { return match.toUpperCase() }) }}
              </template>
              <template v-slot:cell(docusign)="data">
                <a
                  href="javascript:void(0)"
                  v-if="data.item?.status === 'DOCUSIGN_COMPLETED' &&  data.item?.membershipType === 'FDX_OBSERVER'"
                  @click="download(data.item.organizationRequest?.docusign?.envelopeId)"
                >
                  Download EULA
                </a>
                <a
                  href="javascript:void(0)"
                  v-if="data.item?.status === 'DOCUSIGN_COMPLETED' &&  data.item?.membershipType === 'FDX_MEMBER'"
                  @click="download(data.item.organizationRequest?.docusign?.envelopeId)"
                >
                  Download Membership Agreement
                </a>
              </template>
              <template v-slot:cell(onboardingChecklist)="data">
                <a
                  href="javascript:void(0)"
                  @click="gotoChecklist(data.item.organizationRequest)"
                  v-if="(data.item.imisUserMembershipType === 'CONTI' && data.item.organizationRequest && data.item.organizationRequest.organizationStatus && data.item.organizationRequest.organizationStatus.progressType === 'DOCUSIGN_COMPLETED') || (data.item.imisUserMembershipType === 'CONTI' && !data.item.organizationRequest && data.item.status === 'USER_CREATED')"
                >
                  View Onboarding Checklist
                </a>
                <span
                  v-else
                  style="opacity: 0.3"
                >
                  View Onboarding Checklist
                </span>
              </template>
            </b-table>

          </b-col>
        </b-row>
      </div>
    </div>
    <div v-if="downloadStatus">
        <loader
            object="#1c71d8"
            color1="#ffffff"
            color2="#17fd3d"
            size="5"
            speed="2"
            bg="#343a40"
            objectbg="#999793"
            opacity="80"
            disableScrolling="false"
            name="dots"
        ></loader>
    </div>
  </div>
  <div class="container page-content">
    <div class="pt-10 pb-5 text-left container-content" style="margin-left:0; margin-right:0">
      <b-row>
        <b-col>
          <div class="mt-5 mb-3">
            Items per page:
            <div class="dropdown rowperpage"  id="page">
              <button class="btn  rowperpage-btn" type="button" id="page-btn" style="width: 50px !important;position: absolute;right: 45px;top: -30px;text-align: center !important;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"

             >
                {{ pageSize}}
              </button>
              <div class="dropdown-menu rowperpage-menu" aria-labelledby="page-btn" style="min-width: 50px !important;width: 50px !important;position: absolute;top: 10px !important;left: 120px !important;transform: translate3d(120px, 11px, 0px);will-change: transform;">
                <a class="dropdown-item rowperpage-item" style="cursor: pointer; width:50px !important" @click="handlePageSizeChange(size)" v-for="size in pageSizes" :key="size"
                :value="key"
                 :class="{ active: pageSize === size }">
                  {{ size }}
                </a>
              </div>
            </div>
          </div>
        </b-col>
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="pageSize"
            first-number
            last-number
            @change="handlePageChange"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
  BPagination,
} from "bootstrap-vue";
import { mapActions, mapMutations } from "vuex";
import router from "@/router";

export default {
  name: "AdminDashboard",
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
  },
  data() {
      return {
        unsubscribe: "",
        membershipTypes: [],
        organizationTypes: [],
        organizationProgressTypes: [],
        selectedOrgType: "",
        selectedMemberType: "",
        selectedStatus: "",
        rows: 10,
        currentPage: 0,
        pageSize: 10,
        pageSizes: [10, 20, 30, 40, 50],
        sortBy: 'userRequestId',
        sortDesc: true,
        fields: [
          { key: 'userRequestId', sortable: true, label: 'ID' },
          { key: 'firstName', sortable: true, label: 'Name' },
          { key: 'email', sortable: true, label: 'Email Address' },
          { key: 'imisUserMembershipType', sortable: true, label: 'Member Type' },
          { key: 'imisId', sortable: true, label: 'User Imis ID' },
          { key: 'imisUserCreatedDate', sortable: true, label: 'User Imis Created Date' },
          // { key: 'createdDate', sortable: true, label: 'User Created Date' },
          // { key: 'updatedDate', sortable: true, label: 'User Updated Date' },
          { key: 'organizationRequest.imisId', sortable: true, label: 'Org Imis ID' },
          { key: 'organizationRequest.imisOrgCreatedDate', sortable: true, label: 'Org Imis Created Date' },
          { key: 'organizationRequest.name', sortable: true,label: 'Org Name' },
          { key: 'organizationRequest.imisOrgMembershipType', sortable: true, label: 'Org Type' },
          // { key: 'organizationRequest.createdDate', sortable: true, label: 'Org Created Date' },
          // { key: 'organizationRequest.updatedDate', sortable: true, label: 'Org Updated Date' },
          { key: 'status', sortable: true, label: 'Onboarding Status' },
          { key: 'docusign', sortable: true, label: 'Signed Agreements' },
          { key: 'onboardingChecklist', sortable: true, label: 'Follow Up Tasks' },
        ],
        items: [],
        filters: [],
        token: null,
        loading: false,
      }
    },
  methods: {
    ...mapActions([
        "getUserRegistrations",
        "downloadSignedAgreement",
    ]),
    ...mapMutations([
        "setOrganizationRequest",
        "setAdminDashboardRequest",
    ]),
    setUp() {
        if (JSON.parse(this.$store.state.imisUserMembershipType)) {
            this.membershipTypes = JSON.parse(
                this.$store.state.imisUserMembershipType
            );
        }
        if (JSON.parse(this.$store.state.imisOrgMembershipType)) {
            this.organizationTypes = JSON.parse(
                this.$store.state.imisOrgMembershipType
            );
        }
        if (JSON.parse(this.$store.state.organizationProgressTypes) &&
            JSON.parse(this.$store.state.userProgressTypes)) {
            this.organizationProgressTypes = Object.assign(JSON.parse(this.$store.state.organizationProgressTypes),JSON.parse(this.$store.state.userProgressTypes));
        }
    },
    handlePageChange(value) {
      this.currentPage = value;
      let req = {
        page: value,
        size: this.pageSize,
        sortByField:this.sortBy,
        orderType:this.sortDesc===false?"ASC":"DESC",
        filters: this.filters,
        token: this.token
      }
      this.getUserRegistrations(req);
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      let req = {
        page: 0,
        size: size,
        sortByField:this.sortBy,
        orderType:this.sortDesc===false?"ASC":"DESC",
        filters: this.filters,
        token: this.token
      }
      this.getUserRegistrations(req);
    },
    onSearchOrgName(event){

      const timeoutId = window.setTimeout(() => {}, 0);
      for (let id = timeoutId; id >= 0; id -= 1) {
        window.clearTimeout(id);
      }

      setTimeout(() => {
        this.filters = this.filters.filter(function( obj ) {
          return obj.fieldName !== "ORGANIZATION_NAME";
        });
        if(event.target.value) {
          this.filters.push({
            "fieldName": "ORGANIZATION_NAME",
            "fieldType": "STRING",
            "queryType": "SEARCH",
            "value": event.target.value
          })
        }
        this.currentPage = 1;
        let req = {
          page: 1,
          size: this.pageSize,
          sortByField:this.sortBy,
          orderType:this.sortDesc===false?"ASC":"DESC",
          filters: this.filters,
          token: this.token
        }
        this.getUserRegistrations(req);
      }, 2000);

    },
    onChangeOrgType(value) {
      this.selectedOrgType=value;
      this.filters = this.filters.filter(function( obj ) {
        return obj.fieldName !== "ORGANIZATION_TYPE";
      });
      if(value) {
        this.filters.push({
          "fieldName": "ORGANIZATION_TYPE",
          "fieldType": "STRING",
          "queryType": "FILTER",
          "value": value
        })
      }
      this.currentPage = 1;
      let req = {
        page: 1,
        size: this.pageSize,
        sortByField:this.sortBy,
        orderType:this.sortDesc===false?"ASC":"DESC",
        filters: this.filters,
        token: this.token
      }
      this.getUserRegistrations(req);
    },
    onChangeMemberType(value) {
      this.selectedMemberType=value;
      this.filters = this.filters.filter(function( obj ) {
        return obj.fieldName !== "MEMBER_TYPE";
      });
      if(value) {
        this.filters.push({
          "fieldName": "MEMBER_TYPE",
          "fieldType": "STRING",
          "queryType": "FILTER",
          "value": value
        })
      }
      this.currentPage = 1;
      let req = {
        page: 1,
        size: this.pageSize,
        sortByField:this.sortBy,
        orderType:this.sortDesc===false?"ASC":"DESC",
        filters: this.filters,
        token: this.token
      }
      this.getUserRegistrations(req);
    },
    onChangeStatus(value) {
        this.selectedStatus = value;
        this.filters = this.filters.filter(function( obj ) {
        return obj.fieldName !== "ONBOARDING_STATUS";
      });
      if(value) {
        this.filters.push({
          "fieldName": "ONBOARDING_STATUS",
          "fieldType": "STRING",
          "queryType": "FILTER",
          "value": value
        })
      }
      this.currentPage = 1;
      let req = {
        page: 1,
        size: this.pageSize,
        sortByField:this.sortBy,
        orderType:this.sortDesc===false?"ASC":"DESC",
        filters: this.filters,
        token: this.token
      }
      this.getUserRegistrations(req);
    },
    download(id) {
      let req = {
        id: id,
        token: this.token
      }
      this.downloadSignedAgreement(req);
    },
    gotoChecklist(orgRequest) {
      this.setOrganizationRequest(orgRequest);
      this.$router.push("/checklist");
    },
    onSortChanged(payload) {
    if(payload?.sortBy !== 'status' && payload?.sortBy !== 'docusign' && payload?.sortBy !== 'onboardingChecklist'){
      this.sortBy=payload.sortBy;
      this.sortDesc=payload.sortDesc;
      this.currentPage=1;
      let req = {
        page: 1,
        size: this.pageSize,
        sortByField:this.sortBy,
        orderType:this.sortDesc===false?"ASC":"DESC",
        filters: this.filters,
        token: this.token
      }
      this.getUserRegistrations(req);
    }

    },
  },
  mounted() {
    if(this.$store.state?.userToken) {
      const userType = JSON.parse(this.$store.state?.Auth?.user)?.memberType;
      const accesstoken = JSON.parse(this.$store.state?.userToken)?.accessToken;
      this.token = accesstoken;
      if(userType !== 'STAFI' && accesstoken){
        router.push('/');
      } else {
        this.getUserRegistrations({ token: accesstoken,sortByField:this.sortBy,orderType:this.sortDesc===false?"ASC":"DESC", });
      }
    } else {
      this.setAdminDashboardRequest(true);
      router.push('/login');
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  created() {
    this.setUp();
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === "setUserRegistrations" && mutation.payload) {
        var data = JSON.parse(mutation.payload);
        this.items = data?.content;
        this.rows = data?.totalRecords
      }
    });
  },
  computed: {
    userRegistrations() {
      return JSON.parse(this.$store.state?.userRegistrations?.content)
    },
    downloadStatus() {
      return this.$store.state?.downloadStatus
    }
  }
};
</script>
<style scoped>
.heading {
  font-weight: 700;
  font-size: 29px;
  line-height: 34px;
  color: #1978a0;
}
.label {
  font-size: 100%;
  line-height: 1.5;
  color: #333;
  display: inline-block;
  padding: .2em .6em .3em 0;
}
.custom-select {
    height: calc(1.5em + .75rem + 6px);
    font-size: inherit;
}

.dropdown{
  width: 200px !important;
}
.dropdown .btn{
  text-align: left !important;
  padding-left: 5px !important;
  border: 1px solid #ccc !important;
  width:255px !important;
  overflow: hidden;
  height: 36px !important;
}
.medium-fornt{
  font-size: 12.5px !important;
}
.small-fornt{
  font-size: 11px !important;
}
.dropdown-toggle::after {
    position: absolute !important;
    top:15px !important;
    right: -45px;
    vertical-align: .1em !important;
    border-top: .5em solid !important;
    border-right: .5em solid transparent !important;
    border-left: .5em solid transparent !important;
}
.dropdown-menu {
  top: 35px !important;
  transform: none !important;
  width:255px !important;

}
.scroll-bar{
  max-height: 200px;
  overflow-y: scroll !important;
  overflow-x: hidden;
}
.rowperpage-menu {
  top:5px !important;
  left:105px !important;
}
@media only screen and (max-width: 1281px) {
  /* For mobile phones: */
  .container.admindashboard{
    padding-left: 35px !important;
    overflow-y: hidden !important;
  }
  .page-content , .admindashboard-content{
      padding-left: 35px !important;
    }
}
@media  (max-width: 767px) {
  .dropdown .btn {
    width: 340px !important;
}
.dropdown-toggle::after {

  right: -130px;
}
.dropdown-menu{
width:340px !important
}
.b-table{
  width:1460px !important;
}
.medium-fornt, .small-fornt{
  font-size: 14px !important;
}
.scroll-bar{
  max-height: 150px !important;
}
}
@media  (max-width: 320px) {
    .page-content{
      padding-left: 10px !important;
    }
}
.table-border{
  overflow-x: auto;
  width: 1250px;
}
</style>
